export var HERO_EVENT_BUTTONS = {
  Registration: 'registration',
  RegistrationClosed: 'registration-closed',
  Watch: 'watch',
  WatchLater: 'watch-later',
  AdditionalMaterials: 'additional-materials'
};
export var HERO_COLORS = {
  NeutralBackground1Level: 'neutral-background1-level',
  NeutralBackground: 'neutral-background'
};